import { Box, Stack, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";

// Dati della società (da partecipant_team "VB Volley")
const CLUB_NAME = "VB Volley";
const CLUB_ADDRESS = "Impianti Sportivi, Via Impianti Sportivi – Vellezzo Bellini (PV)";

export default function AppFooter() {
    return (
        <Box
            component="footer"
            sx={{
                mt: 4,
                py: 1.5,
                px: 2,
                borderTop: 1,
                borderColor: "divider",
                bgcolor: "rgba(255,255,255,0.85)",
                borderRadius: 2,
            }}
        >
            <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box component="img" src={`${process.env.PUBLIC_URL}/vb-logo.png`} alt="" sx={{ width: 28, height: 28 }} />
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{CLUB_NAME}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <PlaceIcon fontSize="small" color="action" />
                    <Typography variant="body2" color="text.secondary">{CLUB_ADDRESS}</Typography>
                </Stack>
                <Typography variant="caption" color="text.secondary">
                    © {new Date().getFullYear()} Team Manager
                </Typography>
            </Stack>
        </Box>
    );
}
